import * as React from 'react';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { OrderStatusProgress } from '../OrderStatusProgress/OrderStatusProgress';
import { formatOrderTimestamp, getDeliveryLabelKey } from '../../Orders.utils';
import { TOrderCard } from './OrderCard.types';
import '../../Orders.styled.scss';

export const OrderCard: TOrderCard = ({ order, onSelect }) => {
  const localize = useLocalize();
  const { shippingData } = order;
  const customerName =
    `${shippingData.firstName} ${shippingData.lastName}`.trim();
  const deliveryKey = getDeliveryLabelKey(shippingData.deliveryMethod);
  const deliveryLabel = deliveryKey
    ? (localize(deliveryKey) as string)
    : shippingData.deliveryMethod ||
      (localize('admin.orders.delivery.unknown') as string);
  const showParcel =
    shippingData.deliveryMethod?.toLowerCase() === 'inpost' &&
    Boolean(shippingData.parcelLockerCode?.trim());

  return (
    <div className="admin-orders__card">
      <button
        type="button"
        className="admin-orders__card-action"
        onClick={onSelect}
      >
        <div className="admin-orders__card-inner">
          <div className="admin-orders__card-head">
            <h5>{order.orderNumber}</h5>
            <div className="admin-orders__total-wrap">
              <p className="caption admin-orders__total-label">
                {localize('admin.orders.total')}
              </p>
              <h5 className="admin-orders__total-amount">
                {order.totalPrice.toFixed(2)}
              </h5>
            </div>
          </div>

          <div className="admin-orders__meta">
            <div className="admin-orders__meta-block">
              <span className="overline admin-orders__meta-label">
                {localize('admin.orders.customer')}
              </span>
              <p className="body1 admin-orders__meta-value">
                {customerName ||
                  (localize('admin.orders.customer.missing') as string)}
              </p>
            </div>
            <div className="admin-orders__meta-block">
              <span className="overline admin-orders__meta-label">
                {localize('admin.orders.delivery')}
              </span>
              <p className="body1 admin-orders__meta-value">{deliveryLabel}</p>
            </div>
            {showParcel && (
              <div className="admin-orders__meta-block">
                <span className="overline admin-orders__meta-label">
                  {localize('admin.orders.parcel')}
                </span>
                <p className="body1 admin-orders__meta-value">
                  {shippingData.parcelLockerCode}
                </p>
              </div>
            )}
          </div>

          <div className="admin-orders__progress-wrap">
            <OrderStatusProgress status={order.status} />
          </div>

          <div className="admin-orders__footer">
            <p className="body2 admin-orders__footer-line">
              <strong>{localize('admin.orders.userid')}:</strong>{' '}
              {order.userId ??
                (localize('admin.orders.customer.missing') as string)}
            </p>
            <p className="body2 admin-orders__footer-line">
              <strong>{localize('admin.orders.created')}:</strong>{' '}
              {formatOrderTimestamp(order.createdAt)}
            </p>
            <p className="body2 admin-orders__footer-line">
              <strong>{localize('admin.orders.updated')}:</strong>{' '}
              {formatOrderTimestamp(order.updatedAt)}
            </p>
          </div>
        </div>
      </button>
    </div>
  );
};
